/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from "clsx";
import React from "react";

interface BookingLoginTableRowProps {
    className?: string;
    id?: string | number;
    children: React.ReactNode | React.ReactNode[];
}

const BookingLoginTableRow = (props: BookingLoginTableRowProps) => {
    return (
        <div className={clsx("BookingLoginTableRow grid items-center", props.className)} data-id={props.id}>
            {props.children}
        </div>
    );
};

export default BookingLoginTableRow;
